import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';


export const DbnpMappingBasicInfoComponent = ({dbnps, id,onFormChange, dbnp, selectedDbnpMapping, fetchDbnpList }: any) => {
   
    return (<>
 <AccordionContainer
     child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         {id === '0' &&
          <InputContainer
              label="Internal DBNP"
              labelField="Name"
              list={dbnps}
              onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                onFormChange(
                  event.target.value,
                  'ConsumerDBNPId'
                )
              }}
              optionName='Choose ConsumerDBNP'
              type="select"
              value={selectedDbnpMapping?.ConsumerDBNPId}
              valueField="Id"
          />}
         {id === '0' &&
          <InputContainer
              label="Global DBNP Registry"
              labelField="name_of_authorised_signatory"
              list={dbnp}
              onValueChange={(event: any, newValue: any) => {
                // fetchDbnpList(event.target.value)
                onFormChange(
                  event.target.value,
                  'ProviderDBNPId'
                )
              }}
              optionName='Choose ProviderDBNP'
              type="select"
              value={selectedDbnpMapping?.ProviderDBNPId}
              valueField="Id"
          />}
         {id !== '0' &&
         <div>
            <InputLabelContainer label="Global DBNP Registry" />
            <InputLabelContainer label={selectedDbnpMapping?.ProviderDBNPName} />
            </div>}
            {id !== '0' &&
         <div>
            <InputLabelContainer label="Internal DBNP "/>
            <InputLabelContainer label={selectedDbnpMapping?.ConsumerDBNPName} />
            </div>}

<InputContainer
    label="Map Consumer Enabled"
    name="IsDBNPConsumerEnabled"
    onValueChange={(event: any) => {
      onFormChange(
        event,
        'IsDBNPConsumerEnabled'
      )
    }}
    type="checkbox"
    value={selectedDbnpMapping?.IsDBNPConsumerEnabled}
/>

<InputContainer
              label="Map Provider Enabled"
              name="ISDBNPProviderEnabled"
              onValueChange={(event: any) => {
                onFormChange(
                  event,
                  'ISDBNPProviderEnabled'
                )
              }}
              type="checkbox"
              value={selectedDbnpMapping?.ISDBNPProviderEnabled}
          />

     <InputContainer
              label="Map Vendor Role Enabled"
              name="IsDBNPVendorRoleEnabled"
              onValueChange={(event: any) => {
                onFormChange(
                  event,
                  'IsDBNPVendorRoleEnabled'
                )
              }}
              type="checkbox"
              value={selectedDbnpMapping?.IsDBNPVendorRoleEnabled}
          />
   <InputContainer
              label="Map Supplier Role Enabled"
              name="IsDBNPSupplierRoleEnabled"
              onValueChange={(event: any) => {
                onFormChange(
                  event,
                  'IsDBNPSupplierRoleEnabled'
                )
              }}
              type="checkbox"
              value={selectedDbnpMapping?.IsDBNPSupplierRoleEnabled}
          />
      <InputContainer
               label="Map Partner Role Enabled"
               name="IsDBNPPartnerRoleEnabled"
               onValueChange={(event: any) => {
                 onFormChange(
                   event,
                   'IsDBNPPartnerRoleEnabled'
                 )
               }}
               type="checkbox"
               value={selectedDbnpMapping?.IsDBNPPartnerRoleEnabled}
           />
</div>

          }
     expandedPanel="basicInfo"
     headerTitle="Basic Info"
 />
        </>
)}
export default DbnpMappingBasicInfoComponent;
